import { Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'discover-card',
  styleUrl: 'discover-card.scss',
  shadow: true
})
export class DiscoverCard {
  @Prop() cardTitle!: string;
  @Prop() savePercentage!: string;
  @Prop() RP!: string;
  @Prop() bg!: string;
  render() {

    return (
      <Host>
        <slot>
          <div
            class="h-[125px] w-full rounded-2xl relative overflow-hidden bg-center bg-no-repeat card-box-shadow"
            style={{
              backgroundImage: `linear-gradient(0deg, #000000 9.52%, rgba(0, 0, 0, 0) 100%), url(${this.bg})`,
              backgroundSize: '150%'
            }}
          >
            <div class="absolute bottom-2 left-2">
              <p class="text-sm font-medium text-white line-clamp-2 text-ellipsis">{this.cardTitle}</p>
              <div class="flex items-center">
                <save-tag savePercentage={this.savePercentage} />
                <rp-badge rpValue={this.RP} />
              </div>
            </div>
          </div>
        </slot>
      </Host>
    );
  }
}
